module.exports = __webpack_public_path__ + "img/invite-btn.9c19fca0.svg";